import * as React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const inputStyles = {
  "& .MuiInputBase-input": { color: "black" },
  "& .MuiInputLabel-root": { color: "black" },
  "& .MuiInputLabel-root.Mui-focused": { color: "black" },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "black" },
    "&:hover fieldset": { borderColor: "black" },
    "&.Mui-focused fieldset": { borderColor: "black" },
  },
  "& .MuiSelect-icon": { color: "black" },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "black" },
};

export default function HeaderCredit({ filters = {}, setFilters = () => {} }) {
  const set = (key) => (event) =>
    setFilters({ ...filters, [key]: event.target.value });

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: "15px 20px",
        borderRadius: "8px",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
        color: "black",
      }}
    >
      <TextField
        label="Search Driver / Client"
        size="small"
        value={filters.name || ""}
        onChange={set("name")}
        placeholder="Search..."
        sx={{ minWidth: 220, backgroundColor: "#fff", ...inputStyles }}
        InputProps={{ startAdornment: <SearchIcon sx={{ color: "gray" }} /> }}
      />

      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel sx={{ color: "black" }}>Deposit Status</InputLabel>
        <Select
          value={filters.status ?? ""}
          onChange={set("status")}
          label="Deposit Status"
          sx={{ color: "black", backgroundColor: "#fff" }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="0">Lien</MenuItem>
          <MenuItem value="1">Processed</MenuItem>
          <MenuItem value="2">Settled</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="From Date"
        type="date"
        size="small"
        value={filters.from || ""}
        onChange={set("from")}
        InputLabelProps={{ shrink: true, style: { color: "black" } }}
        sx={{ width: 150, ...inputStyles }}
      />

      <TextField
        label="To Date"
        type="date"
        size="small"
        value={filters.to || ""}
        onChange={set("to")}
        InputLabelProps={{ shrink: true, style: { color: "black" } }}
        sx={{ width: 150, ...inputStyles }}
      />
    </Box>
  );
}